"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxName = void 0;
var BoxName;
(function (BoxName) {
    BoxName["BX01"] = "BX01";
    BoxName["BX02"] = "BX02";
    BoxName["BX03"] = "BX03";
    BoxName["BX04"] = "BX04";
    BoxName["BX05"] = "BX05";
    BoxName["BX06"] = "BX06";
    BoxName["BX10"] = "BX10";
    BoxName["BX11"] = "BX11";
    BoxName["BX12"] = "BX12";
    BoxName["BX13"] = "BX13";
    BoxName["BX14"] = "BX14";
    BoxName["BX20"] = "BX20";
    BoxName["BX21"] = "BX21";
    BoxName["BX22"] = "BX22";
    BoxName["BX23"] = "BX23";
    BoxName["BX24"] = "BX24";
    BoxName["BM1"] = "BM1";
    BoxName["BM2"] = "BM2";
    BoxName["BM4"] = "BM4";
    BoxName["PB2"] = "PB2";
    BoxName["PB3"] = "PB3";
    BoxName["PB5"] = "PB5";
})(BoxName || (exports.BoxName = BoxName = {}));
//# sourceMappingURL=BoxName.js.map